import API from "../utils/API"
import Sweetalert from "../utils/Sweetalert"
import ButtonLink from "./ButtonLink"
import CanvaButton from "./CanvaButton"

export default function AdCanvaCardItem({ item, onClick, refresh }) {
  // State

  // Comportements
  const handleDelete = (adId) => {
    if (item.type === "design")
      Sweetalert.fireWarningToast(
        "Vous ne pouvez pas supprimer un design Canva via l'application Adtractive, mais vous pouvez le supprimer directement en passant par l'outil Canva."
      )
    else {
      Sweetalert.fireDeleteConfirm(
        "Êtes-vous sûr ?",
        "Supprimer une ressource Canva ne supprimera pas la diffusion de cette ressource sur les totems.",
        () => {
          API.DELETE(
            "/canva/folder/" + item[item.type].id,
            (response) => {
              Sweetalert.fireSuccessToast(response.data.message)
              refresh() // Appel de la fonction refresh pour rafraîchir la liste des ressources Canva
            },
            (errorMessage) => {
              Sweetalert.fireErrorToast(errorMessage)
            }
          )
        }
      )
    }
  }

  // Rendu
  return (
    <li
      className="d-flex flex-column align-items-center"
      style={{ minHeight: "300px", maxHeight: "300px", gap: "10px" }}
    >
      <ButtonLink
        onClick={onClick}
        className={"d-flex flex-column align-items-center"}
        style={{ width: "100%", gap: "5px" }}
      >
        {item[item.type].thumbnail && (
          <img
            src={item[item.type].thumbnail.url}
            className="rounded-0"
            style={{ maxWidth: "100%", height: "100px" }}
          />
        )}
        <span>{item[item.type].title || item[item.type].name || "Sans titre"}</span>
        <span>{item.type === "folder" ? "Dossier" : item.type === "design" ? "Design" : "Image"}</span>
      </ButtonLink>
      {item[item.type].urls && item[item.type].urls.edit_url && (
        <CanvaButton
          title={"Editer dans Canva"}
          onClick={() => {
            window.location.href = item[item.type].urls.edit_url
          }}
        ></CanvaButton>
      )}
      {(item.type === "design" || item.type === "folder") && (
        <button className="btn btn-danger btn-xs" onClick={() => handleDelete(item[item.type].id)}>
          <i className="fas fa-trash"></i>
          <span className="ml-1">Supprimer</span>
        </button>
      )}
    </li>
  )
}
